import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  withStyles,
  Card,
  CardContent,
  CardActions,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

import Select from "react-select-4-glc";
import {
  getAttribute,
  getAttributeValue,
} from "../../../../Utilities/Functions";
import StepActions from "./stepActions";
import styles from "./styles";

const RecordSelectorStep = (props) => {
  const {
    request,
    entity,
    associatedEntities = [],
    canSkip,
    onCancel,
    onNext,
    onBack,
  } = props;
  const { t } = useTranslation();
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const [recordOptions, setRecordOptions] = useState([]);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [recordError, setRecordError] = useState("");

  useEffect(() => {
    const getRecordName = (e, a) => {
      let name = getAttributeValue(getAttribute(e.attributes, "3"));
      if (a && a.associations && a.associations.length > 0) {
        const associationNames = a.associations
          .map((a) => a.associationTypeName)
          .sort();
        name = `${name}(${Array.from(new Set(associationNames)).join(",")})`;
      }
      return name;
    };

    const options = [];
    const selectedOptions = [];
    if (entity) {
      options.push({
        value: entity.id,
        label: getRecordName(entity),
      });
    }
    for (let ea of associatedEntities) {
      options.push({
        value: ea.entity.id,
        label: getRecordName(ea.entity, ea),
      });
    }

    if (request.records) {
      for (let r of request.records) {
        selectedOptions.push({
          value: r.entity.id,
          label: getRecordName(
            r.entity,
            associatedEntities.find((ae) => ae.entity.id === r.entity.id),
          ),
        });
      }
    }
    setRecordOptions(options);
    setSelectedRecords(selectedOptions);
  }, [entity, associatedEntities, request.records]);

  const handleChange = (ents) => {
    setSelectedRecords(ents || []);
  };

  const handleNext = (event) => {
    setRecordError();
    const records = [];
    for (let sr of selectedRecords) {
      if (sr.value === entity.id) {
        records.push({ entity });
      } else {
        records.push(
          associatedEntities.find((ae) => ae.entity.id === sr.value),
        );
      }
    }
    if (records.length === 0) {
      setRecordError(t("messages.record.documentRequest.recordError"));
      return;
    }
    onNext(true, { selectedRecords: records });
  };

  const handleCancel = (event) => {
    onCancel();
  };

  const handleBack = (event) => {
    onBack();
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography>
              {t(
                "labels.record.documentRequest.steps.recordSelectionStep.header",
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Select
              value={selectedRecords}
              onChange={handleChange}
              isSearchable={true}
              isMulti={true}
              isClearable={false}
              options={recordOptions}
              className={classes.multiSelect}
              menuPortalTarget={document.querySelector(".MuiDialog-root")}
            />
            <div className={classes.errorText}>{recordError}</div>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions disableSpacing>
        <StepActions
          canSkip={canSkip}
          onCancel={handleCancel}
          onNext={handleNext}
          onBack={handleBack}
        />
      </CardActions>
    </Card>
  );
};

export default withStyles(styles, { withTheme: true })(RecordSelectorStep);
